/*
 * mp-experiments.js — minnepote 轻量 A/B 实验框架（前端分流）
 *
 * 设计目标：真实、可分析、对现有主题零侵入。
 *  - 访客级粘性分流：首次访问随机 50/50，写入一年期 first-party cookie，同一访客始终同组。
 *  - 曝光与点击事件经 window.mpTrack（已在 theme.liquid，受 cookie 同意门控）上报。
 *  - 不修改任何按钮文字，不改动既有组件代码。
 *
 * 实验 product_calc：产品页「尺寸指南」按钮
 *  - A（对照）：原样——点击打开尺寸指南抽屉。
 *  - B（实验）：点击改为在新标签页打开交互式尺寸计算器。
 */
(function () {
  'use strict';

  var EXPERIMENTS = {
    product_calc: {
      // B 组点击后打开的计算器页面（minnepote 计算器页 handle）
      url: '/pages/urnekalkulator'
    }
  };
  var COOKIE_DAYS = 365;

  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  /* 访客级粘性分流：返回 'A' 或 'B' */
  window.mpExperiment = function (name) {
    var key = 'mp_exp_' + name;
    // QA 覆盖：网址加 ?mp_exp_<name>=A 或 =B 可强制分组（并写入 cookie 持久化）
    var forced = (location.search.match(new RegExp('[?&]' + key + '=([AB])')) || [])[1];
    if (forced) { setCookie(key, forced, COOKIE_DAYS); return forced; }
    var v = getCookie(key);
    if (v !== 'A' && v !== 'B') {
      v = Math.random() < 0.5 ? 'A' : 'B';
      setCookie(key, v, COOKIE_DAYS);
    }
    return v;
  };

  function track(name, props) {
    if (window.mpTrack) window.mpTrack(name, props);
  }

  /* 实验 product_calc 的接线 */
  var exposed = false;

  function reportExposure(attempt) {
    if (exposed) return;
    if (hasSizeGuide()) {
      exposed = true;
      track('experiment_exposure', {
        experiment: 'product_calc', variant: window.mpExperiment('product_calc')
      });
    } else if (attempt < 4) {
      // 按钮可能客户端延迟渲染 → 重试几次再上报曝光
      setTimeout(function () { reportExposure(attempt + 1); }, 800);
    }
  }

  // 识别「尺寸指南」触发器：① 小文字链接，② 打开模态的大尺寸指南按钮
  function sizeGuideTrigger(target) {
    var a = target.closest('a[data-size-guide-link]');
    if (a) return a;
    var b = target.closest('button[data-modal-button]');
    if (b && /størrelse|storrelse/i.test(b.getAttribute('aria-label') || b.textContent || '')) return b;
    return null;
  }

  function hasSizeGuide() {
    if (document.querySelector('a[data-size-guide-link]')) return true;
    var btns = document.querySelectorAll('button[data-modal-button]');
    for (var i = 0; i < btns.length; i++) {
      if (/størrelse|storrelse/i.test(btns[i].getAttribute('aria-label') || btns[i].textContent || '')) return true;
    }
    return false;
  }

  function onSizeGuideClick(e) {
    if (!sizeGuideTrigger(e.target)) return;
    if (window.mpExperiment('product_calc') === 'B') {
      // 捕获阶段阻断 → 主题的抽屉/模态处理器永不触发，改为新标签打开计算器
      e.preventDefault();
      e.stopImmediatePropagation();
      track('size_guide_click', { experiment: 'product_calc', variant: 'B', action: 'open_calculator' });
      var w = window.open(EXPERIMENTS.product_calc.url, '_blank');
      if (w) { w.opener = null; }
    } else {
      track('size_guide_click', { experiment: 'product_calc', variant: 'A', action: 'open_default' });
    }
  }

  function initProductCalc() {
    // 委托式捕获监听：无条件挂上（与按钮何时渲染无关；无按钮页面无副作用）
    document.addEventListener('click', onSizeGuideClick, true);
    reportExposure(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCalc);
  } else {
    initProductCalc();
  }
})();
